export const contactData = {
  banner: {
    image: "/images/contact-banner.jpg",
    alt: "Contact Us",
  },
  breadcrumb: [
    { label: "HOME", href: "/" },
    { label: "CONTACT US", href: "/contact" },
  ],
  title: "CONTACT",
  titleHighlight: "US",
  reachTitle: "REACH US",
  address: {
    label: "Address :",
    html: "409, Bezzola Complex,<br/> Sion Trombay Road , <br/>Chembur, Mumbai - 400 071. India.",
  },
  phone: {
    label: "Phone :",
    numbers: ["+91-22- 2522 1698", "+91-22- 4250 4650"],
  },
  email: {
    label: "Email :",
    addresses: [
      { label: "info@modepro.com", href: "mailto:info@modepro.com" },
      { label: "mkavalam@modepro.com", href: "mailto:mkavalam@modepro.com" },
    ],
  },
  map: {
    embedSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.2106769466764!2d72.88403680012937!3d19.054472610565597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c8badfc57947%3A0x711ad4ec476e6ae7!2sModepro+India+Pvt+Ltd!5e0!3m2!1sen!2sin!4v1507889458340",
  },
};